import { combineReducers } from 'redux';
import siteState from './state-site';

export default combineReducers({ 
  siteState, 
});
